export const formatNumber = (num = 0, format: ' ' | ','): string =>
  num.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, format);
